import React from 'react';

import { COLOR_L5_PRIMARY_500 } from '../consts';

type Props = {
    fill?: string;
    width?: number;
    height?: number;
};
const CheckboxCheckedIcon = React.memo(function CheckboxCheckedIcon({
    fill = COLOR_L5_PRIMARY_500,
    width = 20,
    height = 20,
}: Props) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect x="0.75" y="0.75" width="18.5" height="18.5" rx="1.25" fill="white" />
            <rect
                x="0.75"
                y="0.75"
                width="18.5"
                height="18.5"
                rx="1.25"
                stroke={fill}
                strokeWidth="1.5"
            />
            <path
                d="M8.01195 11.7196L5.80981 9.56349L4.43877 10.8786L8.01195 14.4518L15.5612 6.84134L14.2888 5.54822L8.01195 11.7196Z"
                fill={fill}
            />
        </svg>
    );
});

export default CheckboxCheckedIcon;
